module.exports = __webpack_public_path__ + "img/theme-sun.648501f3.svg";